export default "__VITE_ASSET__Iihx9x6c__"